<template>
  <div :class="[!activity? 'fullBg' : 'relativeBg']">
    <img :src="bg" alt="" />
  </div>
</template>
<script>
export default {
  props: {
    bg: String,
    activity: String
  },
  computed: {
    bgHeight() {
      // :style="bgHeight"
      return `height:${document.documentElement.clientHeight}px`
    }
  }
}
</script>
<style scoped>
  .relativeBg {
    position: relative;
  }
</style>


// WEBPACK FOOTER //
// Bg.vue?257fec57